import {isNotNil} from 'ramda';

import {AuditAssets} from '../../../store/carAudit/reducerUtils';
import {getFormFieldName} from '../../../utils/getFormFieldName';

export type PhotoDocumentationField = {
  categoryId: string;
  paramDefinitionId: string;
};

export type PhotoDocumentationImageField = PhotoDocumentationField & {
  imageIds: string[];
};

/**
 * Collects the persisted image ids for each photo documentation field from the
 * audit assets store, grouped per field. A bulk delete uses the grouping to
 * optimistically update each field slice (deleteAssets reducer) and the
 * flattened id list to call the bulk delete endpoint.
 */
export const getPhotoDocumentationImageFields = (
  assets: AuditAssets,
  fields: PhotoDocumentationField[]
): PhotoDocumentationImageField[] =>
  fields.map((field) => ({
    ...field,
    imageIds: Object.values(
      assets[getFormFieldName(field.categoryId, field.paramDefinitionId)] ?? {}
    )
      .map((asset) => asset.imageId)
      .filter((imageId): imageId is string => isNotNil(imageId)),
  }));
